import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import logo from "../assets/logo2.png";
import { FaPhoneAlt } from "react-icons/fa"; // Import phone icon from react-icons

const Navbar = ({ activeTab, showSwitch = true }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleTabChange = (tab) => {
    navigate(`/${tab}`);
  };

  // Determine activeTab based on current route if not provided
  const currentTab = activeTab || 
    (location.pathname.startsWith("/tutor") ? "tutor" : 
    location.pathname.startsWith("/student") ? "student" : 
    "student");

  return (
    <StyledNav className="fixed top-0 left-0 right-0 text-black p-4 z-50 flex justify-between items-center mt-0 md:mt-0 mx-4 md:mx-10">
      <div className="h-12 w-36 cursor-pointer" onClick={() => navigate("/")}>
        <img src={logo} alt="Tutor Kendra Logo" />
      </div>

      <div className="items-center gap-4 flex flex-row flex-nowrap">
        <span className="text-xl font-bold items-center hidden lg:flex">
          <div className="py-[3px] -mr-8 relative">
            <PhoneIconCircle>
              <FaPhoneAlt className="phone-icon" />
            </PhoneIconCircle>
          </div>
          <a href="tel:+916388204164" className="bg-green-100 rounded-3xl py-3 pl-12 pr-6">
            +916388204164
          </a>
        </span>
        {showSwitch ? (
          <StyledWrapper>
            <div id="tabFilter" className="filter-switch">
              <input
                checked={currentTab === "student"}
                id="student"
                name="tabs"
                type="radio"
                onChange={() => handleTabChange("student")}
              />
              <label className="option" htmlFor="student">
                Student
              </label>
              <input
                checked={currentTab === "tutor"}
                id="tutor"
                name="tabs"
                type="radio"
                onChange={() => handleTabChange("tutor")}
              />
              <label className="option" htmlFor="tutor">
                Tutor
              </label>
              <span className="background" />
            </div>
          </StyledWrapper>
        ) : (
          <div className="w-[200px] h-[50px]"></div>
        )}
      </div>
    </StyledNav>
  );
};

// New styled component for the phone icon circle
const PhoneIconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55px;
  height: 55px;
  background-color: #4CAF50;
  border-radius: 50%;
  margin-right: -10px;
  
  .phone-icon {
    color: white;
    font-size: 24px;
    transform: rotate(15deg);
  }

  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    
    .phone-icon {
      font-size: 20px;
    }
  }
`;

const StyledNav = styled.nav`
  background: rgba(0, 0, 0, 0);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 15px;
`;

const StyledWrapper = styled.div`
  .filter-switch {
    border: 2px solid #3674b5;
    border-radius: 30px;
    position: relative;
    display: flex;
    align-items: center;
    height: 50px;
    width: 200px;
    overflow: hidden;
  }
  .filter-switch input {
    display: none;
  }
  .filter-switch label {
    flex: 1;
    text-align: center;
    cursor: pointer;
    border: none;
    border-radius: 30px;
    position: relative;
    overflow: hidden;
    z-index: 1;
    transition: all 0.5s;
    font-weight: 500;
    font-size: 16px;
  }
  .filter-switch .background {
    position: absolute;
    width: 49%;
    height: 38px;
    background-color: #3674b5;
    top: 4px;
    left: 4px;
    border-radius: 30px;
    transition: left 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }
  #tutor:checked ~ .background {
    left: 50%;
  }
  #student:checked + label[for="student"] {
    color: #ffffff;
    font-weight: bold;
  }
  #tutor:checked + label[for="tutor"] {
    color: #ffffff;
    font-weight: bold;
  }
  #student:not(:checked) + label[for="student"],
  #tutor:not(:checked) + label[for="tutor"] {
    color: #7d7d7d;
  }

  @media (max-width: 640px) {
    .filter-switch {
      width: 150px;
      height: 40px;
    }
    .filter-switch label {
      font-size: 14px;
    }
    .filter-switch .background {
      height: 28px;
    }
  }
`;

export default Navbar;